<div>
    <a role="link" (click)="openLink()" (keydown.enter)="openLink()" [style.color]="isHighContrast ? '#ff0' : ''" tabindex="0" style="display: flex; flex-direction: row; justify-content: flex-start" data-ui-name="Open Link" data-ui-component="element-render-bookmark-link" data-testid="element-render-bookmark-link-open-link">
      <i *ngIf="!element.isIconDisabled" class="fas fa-link" aria-hidden="true"></i>&nbsp;
      <!-- use tra-md for &nbsp; and other html rendering if needed -->
      <render-highlightable
        [inputString]="element.caption"
        [entryId]="element.entryId"
        [prop]="'caption'"
       data-ui-name="Render highlightable" data-ui-component="element-render-bookmark-link" data-testid="element-render-bookmark-link-render-highlightable">
        <tra-md [isCondensed]="true" [style.position]="element.baseLine ? 'relative' : ''" [style.top.em]="element.baseLine" 
        style="font-weight: normal; text-decoration:underline" [slug]="element.caption"></tra-md>
      </render-highlightable>
      <render-image *ngIf="element.thumbNail" [element]="element.thumbNail" data-ui-name="Render image" data-ui-component="element-render-bookmark-link" data-testid="element-render-bookmark-link-render-image"></render-image>
    </a>
</div>
